import React from "react";

import { useTranslation } from "react-i18next";

import RadioList from "../../form/RadioList";

import type { JSX } from "react";

import type { StorefrontProjectParams } from "../../../api/ProjectAPI.types";

interface PlaylistConfigurationProps {
  onChange: (value: StorefrontProjectParams["playlists_type"]) => void;
  defaultChecked: StorefrontProjectParams["playlists_type"];
  hasAllowMultiplePlaylists: boolean;
}

type PlaylistTypeOptionList = {
  value: StorefrontProjectParams["playlists_type"];
  label: string;
}[];

export default function PlaylistsConfiguration({
  onChange,
  defaultChecked,
  hasAllowMultiplePlaylists,
}: PlaylistConfigurationProps): JSX.Element | null {
  const { t } = useTranslation("editor-platform");

  const optionList: PlaylistTypeOptionList = [
    { value: "disabled", label: t("playlists.disabled") },
    { value: "multiple", label: t("playlists.multiple") },
    { value: "single", label: t("playlists.single") },
  ];

  const handleChange = (value: string): void => {
    onChange(value as StorefrontProjectParams["playlists_type"]);
  };

  if (!hasAllowMultiplePlaylists) return null;

  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">{t("playlistSettings")}</div>
      <RadioList
        defaultChecked={defaultChecked}
        name="storefront-project-playlists"
        onChange={handleChange}
        optionList={optionList}
      />
    </div>
  );
}
